import { PhoneNumberUtil } from 'google-libphonenumber';

export const parsePhoneNumbers = (phoneNumbers) => {
  const phoneUtil = PhoneNumberUtil.getInstance();
  if (Array.isArray(phoneNumbers)) {
    const parsedPhoneNumbers = phoneNumbers.map((phoneNumber) => {
      try {
        const phNo = phoneUtil.parse(phoneNumber);
        return { phoneNumber: phNo.getNationalNumber(), countryCode: phNo.getCountryCode() };
      }
      catch (error) {
        return {}
      }
    });
    return parsedPhoneNumbers;
  } else {
    const phNo = phoneUtil.parse(phoneNumbers);
    return { phoneNumber: phNo.getNationalNumber(), countryCode: phNo.getCountryCode() };
  }
};

export const serializePhoneNumber = (phoneNumbers) => {
  console.log(phoneNumbers);
  if (Array.isArray(phoneNumbers)) {
    return phoneNumbers.map((phNo) => {
      return phNo.countryCode && phNo.phoneNumber ? `+${phNo.countryCode}${phNo.phoneNumber}` : '';
    });
  } else {
    return phoneNumbers.countryCode && phoneNumbers.phoneNumber
      ? `+${phoneNumbers.countryCode}${phoneNumbers.phoneNumber}`
      : '';
  }
};
